<div class="relative flex-grow flex flex-col">
  <div class="flex flex-grow">
    <div class="hidden lg:flex lg:w-5/12 bg-white flex-col items-center p-16">
      <img src="./assets/evsb/img/thank-you.svg" alt="charging a car" class="w-80 mb-8" />
      <span class="h1 te-text-gradient-drive mb-16">
        {{ 'modules.evcSmallBiz.thankYou.sidebar.title' | translate }}
      </span>
      <evsb-secondary-button [renderAsLink]="true" href="{{ homePageLink }}">
        {{ 'modules.evcSmallBiz.thankYou.sidebar.cta' | translate }}
      </evsb-secondary-button>
    </div>
    <div class="hidden lg:block lg:w-1/12"></div>
    <div class="w-full lg:w-5/12 p-8 md:py-16">
      <div class="md:bg-white md:shadow-md md:rounded-4xl md:p-8">
        <div>
          <p class="mention uppercase text-grey-dark text-center mb-4">{{ model.title | translate }}</p>

          <evsb-media-icon [src]="model.alert.src" [className]="'text-white bg-blue-dark rounded-2xl p-4'">
            {{ model.alert.text | translate }}
          </evsb-media-icon>
        </div>

        <div class="my-9">
          <div *ngFor="let item of model.items" class="fulfilment-item">
            <div class="flex">
              <div class="flex-shrink">
                <svg-icon
                  class="fulfilment-checkbox w-8 h-8 block"
                  [src]="item.status.icon"
                  [class]="item.status"
                ></svg-icon>
              </div>
              <div class="flex-grow ml-4">
                <div class="flex">
                  <div class="flex-grow">
                    <span class="font-medium">{{ item.title | translate }}</span>
                  </div>
                  <span class="body-small" [ngClass]="item.status.colorCss">{{ item.status.text | translate }}</span>
                </div>
                <p *ngIf="item.text" [class.pb-10]="item.card">{{ item.text | translate }}</p>

                <div class="max-w-xl" *ngIf="item.card">
                  <evsb-card variant="light" class="-ml-12 z-10" @flyInOutSlow>
                    <evsb-card-header-image [imgSrc]="'./assets/evc/img/total-logo-160x160.png'">
                      <div heading>
                        <div class="mt-2 bg-appleblue uppercase font-bold text-xs px-3 rounded-md">
                          {{ item.card.badge | translate }}
                        </div>
                      </div>
                    </evsb-card-header-image>
                    <evsb-card-body class="block -mt-4" [class.pb-16]="item.card.alert">
                      <p class="font-medium mb-4">{{ item.card.title | translate }}</p>
                      <hr class="mb-4" />
                      <ul class="mb-4 list-checkmark-red">
                        <li *ngFor="let listItem of item.card.list">{{ listItem | translate }}</li>
                      </ul>
                      <div class="block md:inline-block">
                        <evsb-primary-button [fullWidth]="true" (click)="item.card.ctaClick && item.card.ctaClick()">
                          {{ item.card.cta | translate }}
                        </evsb-primary-button>
                      </div>
                    </evsb-card-body>
                  </evsb-card>
                  <div
                    @flyInOutSlowDelayed
                    class="relative bg-white shadow-md rounded-lg overflow-hidden -mt-12 -ml-4 mr-8 z-20"
                    *ngIf="item.card?.alert"
                  >
                    <evsb-media-object
                      align="start"
                      [src]="'./assets/evc/img/piggybank.svg'"
                      class="te-bg-gradient-light-r block"
                    >
                      {{ item.card.alert | translate }}
                    </evsb-media-object>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="block md:inline-block lg:hidden">
          <evsb-secondary-button [fullWidth]="true" [renderAsLink]="true" href="{{ homePageLink }}">
            {{ 'modules.evcSmallBiz.thankYouMail.sidebar.cta' | translate }}
          </evsb-secondary-button>
        </div>
      </div>
    </div>
  </div>
</div>
